"use strict";

const url = "https://mizutani.sjc-dev-ws.com";

const configs = {
    "apiUrl": `${url}/server/api`,
    "filesUrl": url,
    "googleApiKey": "AIzaSyB9944NA5sAh_taSoXP1W06MOFvvZWlEzs",
};

export default configs;
